import React from 'react';

import {Modal, message} from 'antd';

import fetch from './fetch';
import utils from '../utils';

/*基础数据统计*/
const statistics = (options) => {
    return fetch.post('platform/index/foundation/statistics', {})
    .then(response => {
        if(response.code === 200) {
            return response.payload.data || {};
        } else {
            return {
                success: false,
                message: response.message
            };
        }
    });
}

/*指标分析*/
const analysis = (options) => {
    return fetch.post('platform/index/target/analysis', {})
    .then(response => {
        if(response.code === 200) {
            return response.payload.data || [];
        } else {
            return {
                success: false,
                message: response.message
            };
        }
    });
}

/*二级学院分析*/
const distribute = (options) => {
    return fetch.post('platform/index/academic/distribute', {})
    .then(response => {
        if(response.code === 200) {
            return response.payload.data || [];
        } else {
            return {
                success: false,
                message: response.message
            };
        }
    });
}

/*部门测评数据分析*/
const comparison = (options) => {
    return fetch.post('platform/index/eval/comparison', {})
    .then(response => {
        if(response.code === 200) {
            return {
                data: response.payload.data || [],
                meta: {
                    high: response.payload.meta.extParams.highestScore,
                    low: response.payload.meta.extParams.lowestScore,
                }
            };
        } else {
            return {
                success: false,
                message: response.message
            };
        }
    });
}

/*待办事项查询*/
const todolist = (pageSize = 8) => {
    return fetch.post('platform/index/todo/list/'+ pageSize, {})
    .then(response => {
        if(response.code === 200) {
            return response.payload.data.dataList || [];
        } else {
            return {
                success: false,
                message: response.message
            };
        }
    });
}



export default {
    statistics,
    distribute,
    analysis,
    comparison,
    todolist
}